export default __webpack_public_path__ + "static/media/image 6.34f4ee1e.svg";